export enum ItemCategoriesEnum { 
    PACKING ='Packing Material',
    RAW_MATERIAL ='Raw Material',
 }